import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/config/seoHead";
import { municipalityBySlug } from "@/data/municipalities";
import { permanentRedirect, redirectLegacyMunicipality } from "@/lib/legacyRedirects";
import { notFoundUnlessRedirected } from "@/lib/slugGuards";
import { spotPriceLoader } from "@/lib/spotSnapshot";

const ElpriserKommun = lazy(() => import("@/pages/elpriser/ElpriserKommun"));

export const Route = createFileRoute("/elpriser/$slug")({
  beforeLoad: async ({ params }) => {
    // Gammal URL från den tidigare sajten – skicka vidare till spotprisöversikten.
    if (params.slug === "jamfor-elpriser") permanentRedirect("/spotpris");
    redirectLegacyMunicipality("elpriser", params.slug);
    // Okänd kommun: riktig 404 i stället för en 200-sida som skickar vidare i webbläsaren.
    if (!municipalityBySlug(params.slug)) await notFoundUnlessRedirected(`/elpriser/${params.slug}`);
  },
  // Kommunsidan visar spotpris, tabeller och FAQ med dagens snittpris – hämta på servern.
  loader: spotPriceLoader,
  head: ({ params }) => {
    const kommun = municipalityBySlug(params.slug);
    return seoHead(`/elpriser/${params.slug}`, {
      ...(kommun
        ? {
            description: `Aktuella spotpriser, prisutveckling och elavtal för dig som bor i ${kommun.displayName} (${kommun.county} län). ${kommun.displayName} tillhör elområde ${kommun.area}.`,
          }
        : {}),
    });
  },
  component: () => <ElpriserKommun />,
});
